/**
 * @generated SignedSource<<84b498e4b69d6d65034c97ec64e8e687>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoTimeline_item$data = {
  readonly __typename: "TodoComment";
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineComment_todoComment">;
  readonly " $fragmentType": "TodoTimeline_item";
} | {
  readonly __typename: "TodoFeedback";
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineFeedback_feedback">;
  readonly " $fragmentType": "TodoTimeline_item";
} | {
  readonly __typename: "TodoTimelineUpdate";
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdate_todoTimelineUpdate">;
  readonly " $fragmentType": "TodoTimeline_item";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "TodoTimeline_item";
};
export type TodoTimeline_item$key = {
  readonly " $data"?: TodoTimeline_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimeline_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimeline_item",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoTimelineComment_todoComment"
        },
        (v0/*: any*/)
      ],
      "type": "TodoComment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoTimelineUpdate_todoTimelineUpdate"
        }
      ],
      "type": "TodoTimelineUpdate",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoTimelineFeedback_feedback"
        }
      ],
      "type": "TodoFeedback",
      "abstractKey": null
    }
  ],
  "type": "TodoTimelineItem",
  "abstractKey": "__isTodoTimelineItem"
};
})();

(node as any).hash = "419b474f086a0fee4390dba42f07b4e9";

export default node;
